import type { ScoreCriterion } from '../types/casino';

export const scoreCriteria: ScoreCriterion[] = [
  { label: 'Populariteit in Nieuw-Zeeland', weight: 30, description: 'Aanwezigheid in NZ-lobby’s en zoekvolume voor “pokies”.' },
  { label: 'Populariteit bij Nederlandstaligen', weight: 25, description: 'Zoekinteresse en lobbyposities op de Nederlandse markt.' },
  { label: 'Gameplay & mechaniek', weight: 15, description: 'Diepgang van features, bonusrondes en herspeelbaarheid.' },
  { label: 'RTP', weight: 10, description: 'Standaard-RTP van de provider, niet de laagste casinoversie.' },
  { label: 'Mobiele ervaring', weight: 10, description: 'Getest op iPhone en Android, staand en liggend.' },
  { label: 'Levensduur', weight: 5, description: 'Hoe lang de slot al tot de top behoort.' },
  { label: 'Originaliteit', weight: 5, description: 'Brengt de slot iets nieuws of is het een kloon?' },
];
